<div class="" fxLayout="column" fxLayoutAlign="start stretch">
  <h2 mat-dialog-title>{{'SHEDULE2_0.EDITOR.MODALINFO.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p>{{'SHEDULE2_0.EDITOR.MODALINFO.PARTE_1' | translate}}</p>
    <mat-list>
      <mat-list-item *ngFor="let etiqueta of etiquetas; last as last">
        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
        <h4 mat-line><b>{{etiqueta.tag}}</b></h4>
        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
    <p>{{'SHEDULE2_0.EDITOR.MODALINFO.PARTE_2' | translate}}</p>
    <mat-list>
      <mat-list-item *ngFor="let etiqueta of etiquetas; last as last">
        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
        <h4 mat-line><b>{{etiqueta.tag}}</b> = <em>{{etiqueta.info | translate}}</em></h4>
        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
    <p>{{'SHEDULE2_0.EDITOR.MODALINFO.PARTE_3' | translate}}</p>
    <p>{{'SHEDULE2_0.EDITOR.MODALINFO.PARTE_4' | translate}}</p>
  </mat-dialog-content>


  <div fxLayout="column" fxLayoutAlign="start center">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CERRAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</div>
